import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from "@radix-ui/react-icons";
import { AspectRatio } from "@repo/ui/components/ui/aspect-ratio";
import { Skeleton } from "@repo/ui/components/ui/skeleton";
import { Link } from "@tanstack/react-router";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ExperiencesListSkeleton(t0) {
  const $ = _c(2);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 8 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = /*#__PURE__*/_jsx("div", {
      className: "flex flex-col space-y-4",
      children: Array.from({
        length: count
      }).map(_temp)
    });
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
function _temp(_, i) {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-row items-start space-x-3",
    children: [/*#__PURE__*/_jsx("div", {
      className: "h-[120px] w-[180px] shrink-0 overflow-hidden rounded-lg bg-black/5 sm:h-[140px] sm:w-[210px]",
      children: /*#__PURE__*/_jsx(Skeleton, {
        className: "h-full w-full"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-1 flex-col justify-between py-1",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "space-y-2",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: "h-5 w-3/4"
        }), /*#__PURE__*/_jsx(Skeleton, {
          className: "h-4 w-1/2"
        })]
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "mt-2 h-6 w-20"
      })]
    })]
  }, i);
}
export function ExperiencesList(t0) {
  const $ = _c(14);
  const {
    title,
    experiences,
    isLoading: t1,
    categorySlug,
    count: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const count = t2 === undefined ? 8 : t2;
  let t3;
  if ($[0] !== categorySlug || $[1] !== title) {
    t3 = () => {
      if (!title) {
        return null;
      }
      if (categorySlug) {
        return /*#__PURE__*/_jsxs(Link, {
          to: "/upplevelser/$slug",
          params: {
            slug: categorySlug
          },
          className: "group flex items-center gap-2 hover:text-primary",
          children: [/*#__PURE__*/_jsx("h2", {
            className: "text-xl font-bold transition-colors group-hover:text-primary",
            children: title
          }), /*#__PURE__*/_jsx(ChevronRightIcon, {
            className: "h-5 w-5 transition-transform group-hover:translate-x-1"
          })]
        });
      }
      return /*#__PURE__*/_jsx("h2", {
        className: "text-xl font-bold",
        children: title
      });
    };
    $[0] = categorySlug;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const TitleComponent = t3;
  let t4;
  if ($[3] !== TitleComponent || $[4] !== isLoading || $[5] !== title) {
    t4 = title && /*#__PURE__*/_jsx("div", {
      className: "mb-4 px-4 sm:px-0",
      children: isLoading ? /*#__PURE__*/_jsx(Skeleton, {
        className: "h-8 w-[250px]"
      }) : /*#__PURE__*/_jsx("div", {
        className: "flex items-center",
        children: /*#__PURE__*/_jsx(TitleComponent, {})
      })
    });
    $[3] = TitleComponent;
    $[4] = isLoading;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== count || $[8] !== experiences || $[9] !== isLoading) {
    t5 = /*#__PURE__*/_jsx("div", {
      className: "px-4 sm:px-0",
      children: isLoading ? /*#__PURE__*/_jsx(ExperiencesListSkeleton, {
        count: count
      }) : /*#__PURE__*/_jsx("div", {
        className: "flex flex-col space-y-4",
        children: experiences.map(_temp3)
      })
    });
    $[7] = count;
    $[8] = experiences;
    $[9] = isLoading;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = /*#__PURE__*/_jsxs("div", {
      className: "relative z-10",
      children: [t4, t5]
    });
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp3(experience) {
  const primaryMedia = experience.media?.find(_temp2);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-row items-start space-x-3",
    children: [/*#__PURE__*/_jsx(Link, {
      to: "/upplevelser/$slug",
      params: {
        slug: experience.titleSlug
      },
      className: "block h-[120px] w-[180px] shrink-0 overflow-hidden rounded-lg bg-black sm:h-[140px] sm:w-[210px]",
      children: /*#__PURE__*/_jsx(AspectRatio, {
        ratio: 1.5,
        className: "h-full w-full",
        children: primaryMedia && /*#__PURE__*/_jsx("img", {
          src: primaryMedia.url,
          alt: primaryMedia.altText || experience.title,
          className: "h-full w-full object-cover transition-transform duration-500 hover:scale-105"
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-1 flex-col justify-between py-1",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Link, {
          to: "/upplevelser/$slug",
          params: {
            slug: experience.titleSlug
          },
          className: "hover:text-primary",
          children: /*#__PURE__*/_jsx("h3", {
            className: "text-base font-bold transition-colors hover:text-primary",
            children: experience.title
          })
        }), experience.subtitle && /*#__PURE__*/_jsx("p", {
          className: "mt-1 text-xs text-muted-foreground",
          children: experience.subtitle
        })]
      }), /*#__PURE__*/_jsxs(Link, {
        to: "/upplevelser/$slug",
        params: {
          slug: experience.titleSlug
        },
        className: "mt-2 inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline",
        children: ["L\xE4s mer ", /*#__PURE__*/_jsx(ChevronRightIcon, {
          className: "h-4 w-4"
        })]
      })]
    })]
  }, experience.id);
}
function _temp2(m) {
  return m.isPrimary;
}